import React, { useState, useEffect } from 'react'
import Combobox from "@shared/combobox"

import { getRequest } from '@react/helpers/fetch'
import { pathname } from '@react/helpers/fetch'

const initialState = {
  supplier:      {},
  purchaseOrder: {}
}
const PurchaseOrderSelect = ({ data }) => {
  const [state, setState] = useState(initialState)

  const { supplierFieldName, purchaseOrderFieldName } = data
  const excludedPoIds = data.excludedPoIds || []

  const fetchSupplier = (supplierId, purchaseOrderId) => {
    setState(initialState)
    if (supplierId) {
      const path = "/suppliers/:id/build".replace(":id", supplierId)
      const format = 'json'
      const url = pathname({ path, format })
      getRequest(url).then(supplier => {
        if (purchaseOrderId) {
          const purchaseOrder = supplier.purchase_orders.find(po => po.id == purchaseOrderId) || {}
          setState({ supplier, purchaseOrder })
        } else {
          setState({ supplier, purchaseOrder: {} })
        }
      })
    }
  }

  useEffect(() => {
    if (data.supplierId) {
      fetchSupplier(data.supplierId, data.purchaseOrderId)
    }
  }, [])

  const {supplier, purchaseOrder} = state

  const availablePurchaseOrders = (supplier.purchase_orders || []).filter(
    po => !excludedPoIds.includes(po.id)
  )

  return (
    <>
      <div className="form-group">
        <label>{I18n.t("purchase_invoices.supplier")}</label>
        <Combobox
          options         = {data.suppliers}
          value           = {supplier.id}
          onSelectElement = {supplier => fetchSupplier(supplier.id)}
          prompt          = {I18n.t("purchase_invoices.select_supplier")}
          fieldName       = {supplierFieldName}
        />
      </div>

      <div className="form-group">
        <label>{I18n.t("purchase_invoices.purchase_order")}</label>
        <Combobox
          options   = {availablePurchaseOrders}
          value     = {purchaseOrder.id}
          prompt    = {I18n.t("purchase_invoices.select_po")}
          fieldName = {purchaseOrderFieldName}
        />
      </div>
    </>
  )
}

export default PurchaseOrderSelect
